import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { isEmpty } from 'lodash-es';
import { BehaviorSubject } from 'rxjs';
import { filter, tap } from 'rxjs/operators';
import { AlertService } from 'src/app/auth/services/alert.service';
import { get } from 'src/app/_helpers/get';
@Component({
  selector: 'app-modal-alert',
  templateUrl: 'modal-alert.component.html',
  styles: [
    `
      :host {
        position: absolute;
        top: 64px;
        margin: 0 auto;
        max-width: fit-content;
        z-index: 1000;
        left: 612px;
        right: 14%;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalAlertComponent implements OnInit {
  showAlert = new BehaviorSubject<boolean>(false);
  alerts: any[] = [];
  readonly showAlert$ = this.showAlert.asObservable();
  constructor(private alertService: AlertService) {}
  message$: any;
  ngOnInit() {
    this.message$ = this.alertService.getMessage().pipe(
      filter((message) =>
        get(message, 'target', '').includes('app-modal-alert')
      ),
      tap((message) => {
        if (!isEmpty(get<string>(message, 'text'))) {
          this.showAlert.next(message.type !== 'success');
          this.alerts.push(message);
          this.alerts = this.alerts.filter((thing, i, arr) => {
            return (
              arr.indexOf(
                arr.find(
                  (t) =>
                    t.text?.substring(0, 15) === thing.text?.substring(0, 15)
                )
              ) === i
            );
          });
        } else {
          this.alerts = [];
        }
      })
    );
  }
  closeAlert(index) {
    const closeButton = this.alerts.splice(index, 1);
  }
}
